module.exports = __webpack_public_path__ + "img/大图3.6cc783ae.jpg";